import React, { useState } from 'react'
import loadable, { LoadableComponent } from '@loadable/component'

const components: Record<string, LoadableComponent<any>> = {
  'step-1': loadable(() => import('./TwoFactorSetupStepOne')),
  'step-2': loadable(() => import('./TwoFactorSetupStepTwo')),
}

const TwoFactorSetup = ({ type }: { type: 'sms' | 'authenticator' }) => {
  const [currentStep, setCurrentStep] = useState(1)
  const Component = components[`step-${currentStep}`]
  return (
    <div className={'flex flex-1 flex-col overflow-auto h-full font-Spartan'}>
      <div className={'flex h-full flex-col gap-5'}>
        <Component setCurrentStep={setCurrentStep} type={type} />
      </div>
    </div>
  )
}

export default TwoFactorSetup
